import { DateTime } from 'luxon';

export function initCalculateLocalTime(scope: Document | HTMLElement = document) {
  const elements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-calculateLocalTime');
  const timezoneElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-localTimezone');

  // replaces the date and time to the browsers local time
  elements.forEach((element) => {
    const isoString = element.dataset.dateIso || '';
    const format = element.dataset.format || '';
    const locale = element.dataset.locale || 'de';
    let timezone = element.dataset.timezone || 'Europe/Berlin';

    if (isoString === '') {
      return;
    }

    if (timezone === 'CEST') {
      timezone = 'Europe/Berlin';
    }

    const localTime = DateTime.fromISO(isoString, {zone: timezone});

    // replace format to get to luxon format
    if (localTime.isValid) {
      element.innerText = localTime.toLocal().setLocale(locale).toFormat(
        format
          .replace('d', 'dd') //day number
          .replace('m', 'MM') //month number
          .replace('i', 'mm') //minutes
          .replace('Y', 'yyyy') //year 4 digits
          .replace('D', 'ccc') //short day name (Mo.) localized by locale
          .replace('F', 'LLLL') //long month name (June) localized by locale
          .replace('H', 'HH'), //hours
        );
    }
  });

  // replaces the timezone of the date to the local browser timezone (EST, MEZ,...) instead of America/New_York
  // if the browser language is different from the location, this results in timezones like GMT-5
  timezoneElements.forEach((element) => {
    const isoString = element.dataset.dateIso || '';
    const localTime = DateTime.fromISO(isoString);

    if (localTime.isValid) {
      element.innerText = localTime.toLocal().offsetNameShort;
    }
  });
}
